import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { FormGroup, Label, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const CreateClassWithManyTeachers = (props) => {
  const { values, errors, touched, isSubmitting, dismissModal } = props;

  const handleChange = (selected) => {
    values.selectedTeacherIds = selected.map((t) => t.id);
  };

  const handleProgramChange = (c) => {
    values.selectedProgramme = c;
  };

  const handleOrientationChange = (e) => {
    e ? (values.selectedOrientation = e.label) : (e = null);
  };

  return (
    <div className="col-12 col-sm-12">
      <Form>
        <FormGroup>
          <Label>Klassnamn</Label>
          <Field
            className={`form-control ${
              errors.name && touched.name && "is-invalid"
            }`}
            type="input"
            name="name"
            placeholder="Klassens namn"
          />
          {errors.name && touched.name && (
            <div className="invalid-feedback">{errors.name}</div>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="selectTeachers">Välj en eller flera lärare</Label>
          <Select
            placeholder="Välj lärare..."
            isMulti={values.fullAccess}
            noOptionsMessage={() => "Det finns inga valbara lärare för klassen"}
            onChange={(selected) => handleChange(selected)}
            options={values.teachers.map((option) => ({
              ...option,
              label: option.name,
              value: option.id,
              clearableValue: values.fullAccess ? true : false,
            }))}
            defaultValue={
              !values.fullAccess
                ? {
                    label: values.preselectedTeacher.name,
                    value: values.preselectedTeacher.id,
                    clearableValue: false,
                  }
                : ""
            }
          />
        </FormGroup>
        <FormGroup>
          <Label for="selectProgramme">Välj program</Label>
          <Select
            name="selectedProgramme"
            placeholder="Välj program..."
            noOptionsMessage={() => "Det finns inga valbara program"}
            onChange={(e) => handleProgramChange(e)}
            defaultValue={
              values.preselectedProgramme
                ? {
                    label: values.preselectedProgramme.name,
                    value: values.preselectedProgramme.id,
                    clearableValue: false,
                  }
                : ""
            }
            options={values.programmes.map((option) => ({
              ...option,
              label: option.name,
              value: option.id,
              clearableValue: true,
            }))}
          />
        </FormGroup>
        <FormGroup>
          <Label for="selectOrientation">Välj inriktning</Label>
          <CreatableSelect
            name="selectedOrientation"
            isClearable
            placeholder="Välj inriktning eller skriv in namnet för att skapa en ny..."
            noOptionsMessage={() => "Det finns inga valbara program"}
            onChange={(e) => handleOrientationChange(e)}
            options={values.orientations.map((option) => ({
              ...option,
              label: option.name,
              value: option.id.toString(),
              clearableValue: true,
            }))}
            formatCreateLabel={(userInput) =>
              `Klicka här för att skapa:  ${userInput}`
            }
          />
        </FormGroup>
        <div className="d-flex justify-content-end gap-2">
          <Button
            color="secondary"
            outline
            type="button"
            onClick={dismissModal}
          >
            <FormattedMessage id="Close" />
          </Button>
          <Button color="primary" outline type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Vänta..." : "Lägg till"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  //todo-preselct teacher with loggedin if not fullaccess....
  mapPropsToValues: (props) => ({
    name: "",
    school: props.school,
    teachers: props.teachers,
    programmes: props.programmes ? props.programmes : [],
    preselectedProgramme: props.preselectedProgramme
      ? props.preselectedProgramme
      : null,
    orientations: props.orientations ? props.orientations : [],
    selectedTeacherIds: props.fullAccess
      ? []
      : props.preselectedTeacher
      ? props.preselectedTeacher.id
      : 0,
    selectedProgramme: props.preselectedProgramme
      ? props.preselectedProgramme
      : null,
    selectedOrientation: "",
    fullAccess: props.fullAccess ? props.fullAccess : true,
    preselectedTeacher: props.preselectedTeacher,
  }),

  validationSchema: Yup.object().shape({
    name: Yup.string().required(
      <FormattedMessage id="Views.Teacher.CreateClassForm.Error.RequireName" />
    ),
    selectedProgramme: Yup.mixed().required(
      <FormattedMessage id="Views.Teacher.CreateClassForm.Error.RequireProgramme" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setSubmitting }) {
    axios
      .post("/class", {
        name: values.name,
        school: values.school,
        programme: {
          id: values.selectedProgramme.id,
          name: values.selectedProgramme.name,
          Customer: { id: values.school.id, name: values.school.name },
        },
        orientation: { id: 0, name: values.selectedOrientation },
      })
      .then((response) => {
        var classId = response.data.result.id;
        var orientation = null;

        if (response.data.result.orientation)
          orientation = response.data.result.orientation;

        if (values.selectedTeacherIds.length > 0) {
          axios
            .post(
              `/AddTeachersToClass?teacherIds=${values.selectedTeacherIds.join(
                "&teacherIds="
              )}&classId=${response.data.result.id}`
            )
            .then((response) => {
              toast.success(
                <FormattedMessage id="Tostify.Message.AddedClass" />,
                TOAST_CONFIG
              );
              resetForm();
              //Skapa klassobject & skicka med tillbaka för uppdatering

              var newclass = {
                name: values.name,
                id: classId,
                orientation: orientation,
                students: [],
                teachers: response.data.result,
              };

              props.reloadClasses(newclass, values.selectedProgramme.id);
              props.dismissModal();
            })
            .catch((err) => {
              console.warn(err);
              toast.warn(err.response.data, TOAST_CONFIG);
            });
        } else {
          toast.success(
            <FormattedMessage id="Tostify.Message.AddedClass" />,
            TOAST_CONFIG
          );
          resetForm();
          var newclass = {
            name: values.name,
            id: classId,
            orientation: orientation,
            students: [],
            teachers: [],
          };

          props.reloadClasses(newclass, values.selectedProgramme.id);
          props.dismissModal();
        }
      })
      .catch((err) => {
        console.warn(err);
        toast.error(err.response.data, TOAST_CONFIG);
      });

    setSubmitting(false);
  },
})(CreateClassWithManyTeachers);

export default FormikForm;
